/* istanbul ignore file */

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { ITermWithTranslations } from "./TermTranslations.state";

export const getTermTranslations = async (termId: string, status: string) =>
  (
    await getClientFor(mainApi.name).get<ITermWithTranslations>(`/terms/${termId}/translations`, {
      params: {
        status: status
      }
    })
  ).data;
